import { useState, useEffect } from 'react'
import { Link, useHistory, useParams } from 'react-router-dom'
import { Card, CardBody, CardTitle, CardSubtitle, CardText, Button } from 'reactstrap'
import axios from 'axios';
import base_url from '../../utils/config'
import { toast } from 'react-toastify';
import { Table } from 'react-bootstrap';
const ProductList = ({ }) => {
  const history = useHistory();
  const { id } = useParams();
  const [productList, setProductList] = useState([])
  useEffect(() => {
    getProductListApi()
  }, [])

  const getProductListApi = () => {
    axios.get(`${base_url}/getAllProduct`).then((response) => {
      console.log('getAllCourseResponse: ', response.data)
      setProductList(response.data.data)
    });
  }

  const onDelete = (courseId) => {

    axios.get(base_url + '/deleteProduct/' + courseId).then((response) => {
      if (response.status === 200) {
        toast.success(response.data.message)
        getProductListApi()
      }
    });
  }


  

  return (
    <div>
      <Button className='btn-primary-startNow btn-font mt-3 p-2 mb-1' onClick={() => { history.push('/addProduct/null') }}>Add New Model</Button>
      <Button className='btn-primary-startNow btn-font mt-3 p-2 mb-1 ms-2' onClick={() => { history.push('/bulkUpload/null') }}>Bulk Upload</Button>
      
      
      <div class="profile-banner mt-3">
        <h1>Model List</h1>
      </div>
      <div >

        <Table striped bordered hover>
          <thead>
            <tr>
              <th>#</th>
              <th>Model Name</th>
              <th></th>
              <th></th>
            </tr>
          </thead>
          <tbody>
            {productList?.map((item, index) => (
              <tr>
                <td>{index + 1}</td>
                <td>{item.prodName}</td>
                <td></td>
                <td> {/*<Button className='ms-3' onClick={()=>{
              history.push('/productDetailList/'+catId+'/'+subCatId+'/'+supSubCatId+"/"+item._id)
            }} >View Product Details</Button>*/}
                  <Button className='ms-3' onClick={() => { history.push('/addProduct/' + item._id + '?isEdit=1') }} >Edit</Button>
                  <Button className='ms-3' onClick={() => {
                    if (window.confirm('Are you sure you want to delete?')) {
                      onDelete(item._id)
                    }
                  }}>Delete</Button></td>
              </tr>
            ))}
          </tbody>
        </Table>
      </div>


    </div>
  );


};
export default ProductList;